<svg role="img" [class]="name + ' ' + color">
    <use [attr.href]="'#' + name"></use>
</svg>
